<!--
  +---------------------------------------------------------------------------------------
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     账号中心-个人资料
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fam-me mt-md">

    <el-card v-loading="loading" shadow="never" class="mb-md" >
      <div class="text-bold font-md">基本信息</div>
      <el-card shadow="never" :body-style="{ margin: '40px auto', 'max-width': '1200px' }">
        <el-form ref="displayForm" class="display-form mt-lg" label-position="left" label-width="120px">
          <el-form-item label="用户名">
            <el-col :span="18">
              <span>{{ user.username }}</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <span class="text-muted font-2x middle">
                <el-popover placement="top" trigger="hover">
                  用户名不可变更
                  <span slot="reference" class="iconfont">&#xe691;</span>
                </el-popover>
              </span>
            </el-col>
          </el-form-item>
          <el-form-item label="登录密码">
            <el-col :span="18">
              <span>********</span>
              <span class="span font-lg middle text-success"><i class="el-icon-circle-check" /></span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="passwordDialogShow = true">修改</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="企业名称">
            <el-col :span="18">
              <span class="mr-sm">{{ god.full_name }}</span>
              <el-tag v-if="god.certified == 0" type="danger" class="auth">未认证</el-tag>
              <el-tag v-if="god.certified == 2 || god.certified == 3" type="warning" class="auth">认证中</el-tag>
            </el-col>
            <el-col :span="6" class="text-right">
              <div v-if="god.certified === 1" class="text-success">
                <i class="iconfont icon-autherized icon-lg"></i>
              </div>
              <div  v-if="god.certified === 2" class="text-warning">
                <i class="iconfont icon-authenticating icon-lg"></i>
              </div>
              <el-button v-if="god.certified === 3" type="text" class="text-danger" @click="$router.push('/fam/authentication')">重新认证</el-button>
              <el-button v-if="!god.certified" type="text" @click="$router.push('/fam/certify')">立即认证</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="企业简称">
            <el-col :span="18">
              <span v-if="god.short_name">
                <span>{{ god.short_name }}</span>
              </span>
              <div v-else class="text-muted">未设置</div>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="handleShortname">设置</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="企业邮箱">
            <el-col :span="18">
              <span v-if="god.email">
                <span>{{ god.email }}</span>
              </span>
              <div v-else class="text-muted">未设置</div>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="handleEmail">设置</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号">
            <el-col :span="18">
              <span v-if="!user.mobile" class="text-muted">{{ '未设置' }}</span>
              <div v-else>
                <span>{{ user.mobile | mobileFilter }}</span>
                <span class="span font-lg middle text-success"><i class="el-icon-circle-check" /></span>
              </div>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="mobileDialogShow = true">设置</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </el-card>
    </el-card>

    <el-card v-loading="loading" v-if="god.ap_key" shadow="never" class="mb-md" >
      <div class="text-bold font-md">账号信息</div>
      <el-card shadow="never" :body-style="{ margin: '20px auto 0', 'max-width': '1200px' }">
        <el-form ref="accountForm" class="account-form" label-position="left" label-width="120px">
          <el-form-item label="AP_KEY">
            <el-col :span="18">
              <span>{{ god.ap_key }}</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="handleCoply(god.ap_key,$event)">复制</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="AP_SECRET">
            <el-col :span="18">
              <span>{{ god.ap_secret }}</span>
            </el-col>
            <el-col :span="6" class="text-right">
              <el-button type="text" @click="handleCoply(god.ap_secret,$event)">复制</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </el-card>
    </el-card>
    <f-password-modify :show.sync="passwordDialogShow" />
    <f-mobile-bind :show.sync="mobileDialogShow" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import clipboard from "@/utils/clipboard";
import { mobileFilter } from '@/utils/common'

export default {
  name: 'FamMe',

  components: {
    FPasswordModify: () => import('./components/FPasswordModify'),
    FMobileBind: () => import('./components/FMobileBind')
  },

  filters: {
    mobileFilter
  },

  data () {
    return {
      loading: false,
      passwordDialogShow: false,
      mobileDialogShow: false
    }
  },

  computed: {
    god () {
      return this.$store.state.godStore
    },

    user () {
      return this.$store.state.userStore
    },

    wechat () {
      return Object.assign({}, this.$store.state.godStore.wechat)
    },
  },

  created () {
    this.getUserInfoAction().then(() => {
    }).catch(e => {
      console.log(e)
    })
    this.getCustomizationInfoAction().then(() => {
    }).catch(e => {
      console.log(e)
    })
  },

  methods: {
    ...mapActions([
      'setUserInfoAction',
      'getUserInfoAction',
      'setGodCustomizationAction',
      'getCustomizationInfoAction',
    ]),

    apply() {
      const state = encodeURIComponent(window.location.href);
      const godid = this.$store.state.godStore.godid;
      window.location.href = `https://api.frippler.com/super/index.php?c=account&a=platform&do=qrpre&godid=${godid}&state=${state}`
    },

    setUserInfo (data) {
      this.setUserInfoAction(data).then((res) => {
        if (!res.errno) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    handleShortname () {
      this.$prompt('请修改您的公司简称', {
        inputValue: this.god.short_name,
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.$store.dispatch('setGodCustomizationAction', { short_name: value }).then((res) => {
          if (!res.errno) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        // 取消
      })
    },
    handleEmail() {
      this.$prompt('请设置您的企业邮箱', {
        inputValue: this.god.email,
        closeOnClickModal: false,
      }).then(({ value }) => {
        this.$store.dispatch('setGodCustomizationAction', { email: value }).then((res) => {
          if (!res.errno) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        // 取消
      })
    },

    showRejectReason (msg) {
      this.$confirm(msg, '认证失败原因', {
        confirmButtonText: '重新认证',
        cancelButtonText: '取消',
      }).then(() => {
        this.$router.push('/fam/authentication')
      }).catch(() => { })
    },

    handleCoply(text, event) {
      clipboard(text, event);
    }
  }
}
</script>

<style lang="scss" scoped>
.text-danger:hover {
  color: #e64340;
}
.auth {
  border-radius: 14px;
  padding: 0px 16px;
}
.icon-lg {
  font-size: 24px;
}
.image-editor {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  position: relative;
  .el-avatar {
    position: absolute;
    top: 0;
    left: 0;
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 50%;
    cursor: pointer;
    color: #f9f9f9;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
    &:hover {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
.el-form.account-form .el-form-item__content {
    border-bottom: 1px solid #ebeef5;
}
</style>
